"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _ui = require("../../ui");
var _constants = require("../../../constants");
var _Label = require("./Label");
var _excluded = ["tickers", "balances"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SelectInput = function SelectInput(_ref) {
  var tickers = _ref.tickers,
    _ref$balances = _ref.balances,
    balances = _ref$balances === void 0 ? [] : _ref$balances,
    props = _objectWithoutProperties(_ref, _excluded);
  var options = balances.length !== 0 ? balances.filter(function (balance) {
    return tickers.includes(balance.ticker);
  }).map(function (balance) {
    return {
      value: balance.ticker,
      label: /*#__PURE__*/_react.default.createElement(_Label.Label, {
        ticker: balance.ticker,
        balance: balance
      })
    };
  }) : tickers.map(function (ticker) {
    return {
      value: ticker,
      label: /*#__PURE__*/_react.default.createElement(_Label.Label, {
        ticker: ticker
      })
    };
  });
  return /*#__PURE__*/_react.default.createElement(_ui.SelectInput, _extends({}, props, {
    options: options,
    defaultValue: options[0].value,
    isSearchable: true,
    filterOption: function filterOption(_ref2, value) {
      var _TickerFullName;
      var data = _ref2.data;
      if (value && data.value === 'ALL') return false;
      return data.value.includes(value.toUpperCase()) || ((_TickerFullName = _constants.TickerFullName[data.value]) === null || _TickerFullName === void 0 ? void 0 : _TickerFullName.toLowerCase().includes(value.toLowerCase()));
    }
  }));
};
exports.SelectInput = SelectInput;